import MainHeader from './main-header'
import MainFooter from './main-footer'

export default {
	MainHeader,
	MainFooter
}